import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import cn from 'classnames';

import {useNavigate} from 'react-router-dom';
import SabteForushgah from '../../../assets/image/shop/sabteForushgah.png';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import {useAuth} from '../../../context/authContext';
import useGetMyStoreStoreLabNotifModal from '../../../services/hookService/getMyStoreStoreLabNotifModal/useGetStoreAndLabModal';
import {RootState} from '../../../store/redux';
import {
  addRegisterStoreFormData,
  resetRegisterStore,
} from '../../../store/redux/registerStore';
import {handleStoreAndLabModalTitle} from '../home/constants';
import StoreAndLabResultModal from './modal/storeAndLabResultModal';
import StoreAndLabShowPendingModal from './modal/storeAndLabShowPendingModal';
import useGetProfile from '../../profile/hooks/useGetProfile';
import {googleAnalyticsInstance} from '../../../utilities/helper/googleAnalitics';

const MyStore = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.registerStore);

  const {supplierProfile} = useAuth();

  const {refetch} = useGetProfile(supplierProfile?.guid || '', true);

  const {storeAndLabModal, myStoreStoreLabNotifModalIsLoading} =
    useGetMyStoreStoreLabNotifModal({data: supplierProfile});

  const [showModal, setShowModal] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const storeTexts = [
    {
      id: '1',
      title: 'دریافت اعلان‌های نیازمندی خریداران',
      icon: 'icon-nameCheckmark',
    },
    {
      id: '2',
      title: 'ارتباط هوشمنـــــــد با مـــزارع و باغات',
      icon: 'icon-nameCheckmark',
    },
    {
      id: '3',
      title: 'افــــزایش ۱۰ برابری بازدید آگهـــی‌ها',
      icon: 'icon-nameCheckmark',
    },
  ];

  useEffect(() => {
    if (
      supplierProfile?.store?.store_status === 'pending' ||
      supplierProfile?.lab?.lab_status === 'pending'
    ) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [supplierProfile]);

  useEffect(() => {
    if (storeAndLabModal) {
      setEditModal(true);
    } else {
      setEditModal(false);
    }
  }, [storeAndLabModal]);

  useEffect(() => {
    refetch();
  }, []);

  return (
    <div className="relative flex flex-col w-full h-full ">
      <CustomHeader
        title="فروشگاه من"
        preIcon="icon-nameArrow---Right"
        onClick={() => navigate(-2)}
        postComponent={() => (
          <i
            className={`icon-namechat text-[25px] text-gray-700`}
            onClick={() => {
              navigate('/my-chats');
              googleAnalyticsInstance.eventGoogleAnalytics({
                category: 'myChat',
                action: 'رو چت من در هدر کلیک شد',
              });
            }}
          />
        )}
        isActiveRightIcon={true}
      />

      <>
        <div className="flex flex-col items-center h-full  mt-28">
          <img src={SabteForushgah} alt="" className="-rotate-90 h-52 w-52" />
          <h3 className="mt-4 text-red-800">
            <strong>۵۰ برابر</strong>
            افزایش فروش
          </h3>
          <span className="text-lg text-red-800">
            فقط با ثبت فروشگاه اختصاصی{' '}
          </span>
          <div className="flex flex-col gap-2 mt-6">
            {storeTexts.map(item => (
              <div key={item.id} className="text-gray-950">
                <i className={item.icon} />
                <span>{item.title}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="flex items-center justify-center">
          <button
            // className={cn(
            //   'text-white bg-farm-shop-500  w-full h-12 rounded max-w-52 mb-3',
            //   'bg-farm-shop-300'&& myStoreStoreLabNotifModalIsLoading,
            // )}
            className={cn(
              'text-white w-full h-12 rounded max-w-52 mb-3',
              {'bg-farm-shop-300': myStoreStoreLabNotifModalIsLoading},
              {'bg-farm-shop-500': !myStoreStoreLabNotifModalIsLoading},
            )}
            onClick={() => {
              dispatch(resetRegisterStore({}));
              navigate('/register-store-lab');
            }}
            disabled={myStoreStoreLabNotifModalIsLoading}
          >
            ثبت فروشگاه
          </button>
        </div>
        {showModal && (
          <StoreAndLabShowPendingModal
            isSuccessModal={showModal}
            setIsSuccessModal={setShowModal}
            removeOnClick={() => {
              navigate('/home');
              setShowModal(false);
            }}
            understandOnClick={() => {
              navigate('/home');
              setShowModal(false);
            }}
            type={
              supplierProfile?.store?.store_status === 'pending'
                ? 'store'
                : 'lab'
            }
          />
        )}
        {!myStoreStoreLabNotifModalIsLoading && !showModal && (
          <StoreAndLabResultModal
            title={
              storeAndLabModal &&
              handleStoreAndLabModalTitle('title', storeAndLabModal)
            }
            desc={
              storeAndLabModal &&
              handleStoreAndLabModalTitle('desc', storeAndLabModal)
            }
            isSuccessModal={editModal}
            setIsSuccessModal={setEditModal}
            successBtnTitle="ورود به فروشگاه"
            isEdit={storeAndLabModal?.modal_type === 'rejected'}
            rejectedOnClick={() => {
              navigate('/home');
              setEditModal(false);
            }}
            removeOnClick={() => {
              navigate('/home');
              setEditModal(false);
            }}
            editOnClick={() => {
              if (storeAndLabModal?.lab?.guid) {
                navigate(
                  `/edit-register-store/lab/${storeAndLabModal?.lab?.guid}`,
                  {state: {mode: 'edit', tab: 2}},
                );

                dispatch(
                  addRegisterStoreFormData({
                    selectedInput: {...state, id: 2, code: 102},
                  }),
                );
              } else {
                navigate(
                  `/edit-register-store/store/${storeAndLabModal?.store?.guid}`,
                  {state: {mode: 'edit', tab: 2}},
                );
              }
              setEditModal(false);
            }}
            onSuccessBtnClick={() => {
              setEditModal(false);
              navigate('/my-store-info');
            }}
          />
        )}
      </>

      <MainFooter />
    </div>
  );
};

export default MyStore;
